/**
 * WallpaperConfigurator
 *
 * @descriptionReturn nr of rolls or meters, based on wall width and height. All sizes are in cm.
 */
(async() => {

  class WallpaperConfigurator extends HTMLElement {
    constructor() {
      super(); // HTMLElement constructor

      this.state = {
        type: 'meters',
        amount: null
      };

      // Get the state from the state data json
      if (this.dataset.config) {
        const config = JSON.parse(this.dataset.config);
        if (config) {
          this.state = {
            ...this.state,
            ...config
          }
        }
      }

      // Select element label
      this.resultLabel = this.querySelector('[data-result="label"]');
      this.resultAmount = this.querySelector('[data-result="amount"]');

      // Inputs
      this.form = this.querySelector('[data-form]');
      this.wallWidth = this.querySelector('[data-wall-width]');
      this.wallHeight = this.querySelector('[data-wall-height]');

      // Handle calculation form submit
      this.form.addEventListener('submit', (event) => {
        this.handleFormSubmit(event);
      });

      // this.form.addEventListener('input', (event) => {
      //   this.handleFormSubmit(event);
      // });

      // Handle add product to cart
      this.addRollsToCart = this.querySelector('[data-add-rolls-to-cart]');
      this.addRollsToCart.addEventListener('click', (event)=> {
        this.addProductToCart(event);
      });

    }

    /**
     * handleFormSubmit
     * @param {Object} event
     * returns Void
     */
    handleFormSubmit(event) {
      event.preventDefault();
      this.toggleLoading(true);

      const wallWidth = parseInt(this.wallWidth.value);
      const wallHeight = parseInt(this.wallHeight.value);

      // Stop and return when it is not a number
      if(isNaN(wallWidth) || isNaN(wallHeight)) {
        this.hideResult();
        this.toggleLoading(false);
        return;
      }

      // If wallpaper has a height, set type to rolls
      if(this.state.wallpaperHeight > 0) {
        this.state.type = 'rolls'
      }


      // Store height of the wall
      this.state.wallHeight = wallHeight;

      // Store the width of the wall + add overlap from settings
      this.state.wallWidth = wallWidth + this.state.overlapWidth;

      // Nr of strokes required = wallWidth / wallpaperWidth
      this.state.requiredStrokes = Math.ceil(this.state.wallWidth / this.state.wallpaperWidth);

      // Required strokeHeight = wallHeight + add overlap from settings
      this.state.requiredStrokeHeight = this.state.wallHeight + this.state.overlapHeight;

      // If wallpaper has a pattern, required strokeHeight = set to fit a whole number of patterns that fit in (this.state.wallHeight + add overlap from settings)
      if (this.state.patternHeight > 0) {
        this.state.requiredStrokeHeight = Math.ceil((this.state.wallHeight + this.state.overlapHeight) / this.state.patternHeight) * this.state.patternHeight;
      }

      // Endless wallpaper, order per meter
      if(this.state.type === 'meters') {

        // Required length = requiredStrokes * strokeHeight (in meters)
        this.state.amount = Math.ceil(this.state.requiredStrokes * this.state.requiredStrokeHeight / 100);

      // Roll wallpaper, order per roll
      } else {

        // Strokes per roll = wallpaperHeight / requiredStrokeHeight
        this.state.strokesPerRoll = Math.floor( this.state.wallpaperHeight / this.state.requiredStrokeHeight);

        // If wall height exceeds paper height
        if(this.state.strokesPerRoll < 1){
          alert(this.state.translations.wall_height_warning);
          this.hideResult();
          this.toggleLoading(false);
          return;
        }

        // Required rolls = requiredStrokes / strokesPerRoll
        this.state.amount =  Math.ceil(this.state.requiredStrokes / this.state.strokesPerRoll);
      }

      this.showResult();
      this.toggleLoading(false);
    }

    /**
     * showResult
     */
    showResult() {

      // Set data amount
      this.resultAmount.textContent = this.state.amount;

      if(this.state.type === 'rolls') {

        // Set data label
        this.state.amount > 1 ? this.resultLabel.textContent = this.state.translations.rolls_needed : this.resultLabel.textContent = this.state.translations.roll_needed;

      } else if (this.state.type === 'meters') {

        // Set data label
        this.state.amount > 1 ? this.resultLabel.textContent = this.state.translations.meters_needed : this.resultLabel.textContent = this.state.translations.meter_needed;

      }
      this.querySelector('[data-result="container"]').classList.remove('hidden');
    }

    /**
     * hideResult
     */
    hideResult() {
      this.querySelector('[data-result="container"]').classList.add('hidden');
    }

    /**
     * addProductToCart
     * @param {Object} event
     */
    addProductToCart(event) {
      event.preventDefault();
      event.currentTarget.classList.add('loading');
      const form = this.closest('product-info').querySelector('product-form form');
      const quantity = form.querySelector('input[name="quantity"]')
      const currentQuantity = quantity.value;
      quantity.value = this.state.amount;
      form.querySelector('button[name="add"]').click();
      quantity.value = currentQuantity;
      event.currentTarget.classList.remove('loading');
    }

    /**
     * toggleLoading
     * @param {Boolean} loading
     */
    toggleLoading(loading = false) {
      if(loading) {
        this.classList.add('loading');
      } else {
        this.classList.remove('loading');
      }
    }
  }

  if(!customElements.get('wallpaper-configurator')) {
    customElements.define('wallpaper-configurator', WallpaperConfigurator);
  }

})();
